import React from 'react';
import PropTypes from 'prop-types';

// [texto](url) | url con esquema o www | email
const PATRON = '\\[([^\\]\\n]+)\\]\\(\\s*((?:https?:\\/\\/|mailto:|www\\.)[^\\s)]+)\\s*\\)' +
  '|((?:https?:\\/\\/|www\\.)[^\\s<>"\']+)' +
  '|([^\\s<>"\'@]+@[^\\s<>"\'@]+\\.[a-z]{2,})';

// Separa la puntuacion final que no forma parte del enlace: "visita www.web.com."
const recortarPuntuacion = (valor) => {
  let enlace = valor;
  let resto = '';
  while (enlace.length > 0 && /[.,;:!?¡¿'"”’)\]}]$/.test(enlace)) {
    const ultimo = enlace.slice(-1);
    if (ultimo === ')') {
      const abiertos = (enlace.match(/\(/g) || []).length;
      const cerrados = (enlace.match(/\)/g) || []).length;
      if (cerrados <= abiertos) break;
    }
    resto = `${ultimo}${resto}`;
    enlace = enlace.slice(0, -1);
  }
  return [enlace, resto];
};

const construirHref = (valor, esEmail) => {
  if (esEmail) return `mailto:${valor}`;
  if (/^www\./i.test(valor)) return `https://${valor}`;
  return valor;
};

const TextoConEnlaces = ({ texto }) => {
  if (typeof texto !== 'string' || texto === '') return null;
  const patron = new RegExp(PATRON, 'gi');
  const partes = [];
  let ultimoIndice = 0;
  let coincidencia = patron.exec(texto);
  while (coincidencia !== null) {
    const [completo, textoMd, urlMd, url, email] = coincidencia;
    if (coincidencia.index > ultimoIndice) {
      partes.push(texto.slice(ultimoIndice, coincidencia.index));
    }
    const [enlace, resto] = recortarPuntuacion(urlMd || url || email);
    if (enlace) {
      partes.push(
        <a
          key={`enlace-${coincidencia.index}`}
          href={construirHref(enlace, !urlMd && !!email)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {textoMd || enlace}
        </a>
      );
      if (!urlMd && resto) partes.push(resto);
    } else {
      partes.push(completo);
    }
    ultimoIndice = coincidencia.index + completo.length;
    coincidencia = patron.exec(texto);
  }
  if (ultimoIndice < texto.length) partes.push(texto.slice(ultimoIndice));
  return <>{partes}</>;
};

TextoConEnlaces.propTypes = {
  texto: PropTypes.string
};

export default TextoConEnlaces;
